import { useSelector } from "react-redux";
import { useMemo } from "react";
import { hasCheckSecurity } from "@/util/common_function";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";

const ALWAYS_ALLOWED_KEYS = [
  "dashboard",
  // "bookings",
  // "users",
  // "warrants",
];

// Filters the Go menu down to modules the current user's security rules
// actually grant VIEW on. Gated on userSecurityUpdated — set by
// SetSecurityRules (common_function.js) only once the real security-rules
// cascade has finished loading — because userDetail itself becomes available
// before that async fetch resolves. Computing (and previously, caching to
// localStorage) this filter any earlier meant it ran against an
// as-yet-empty rule set, which defaults to allow-everything and, worse,
// used to get locked in for the rest of the session.
export const getAllowedMenu = (menuList = []) => {
  const { userDetail, userSecurityUpdated } = useSelector(
    (state) => state.userDetail,
  );

  const finalMenu = useMemo(() => {
    if (!userDetail || !userSecurityUpdated) return [];

    const securityAllowed = menuList.filter((item) =>
      hasCheckSecurity(
        Security_Types.functionality,
        Entity_types.module,
        LABELS_CAPITAL.VIEW,
        item.label,
      ),
    );

    const alwaysAllowedModules = menuList.filter((item) =>
      ALWAYS_ALLOWED_KEYS.includes(item.key),
    );

    const finalList = [
      ...alwaysAllowedModules,
      ...securityAllowed.filter(
        (x) => !ALWAYS_ALLOWED_KEYS.includes(x.key),
      ),
    ];

    return finalList.sort((a, b) => a.label.localeCompare(b.label));
  }, [userDetail, userSecurityUpdated, menuList]);

  return finalMenu;
};
